import { msg, Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import Container from "../../../common/Container";
import Footer from "../../../common/Footer";
import FooterButton from "../../../common/FooterButton";
import useDisplayMessage from "../../../common/lib/hooks/useDisplayMessage";
import useScaleWeight from "../../../common/lib/hooks/useScaleWeight";
import KaAlert from "../../../common/lib/KaAlert";
import ScaleReconnection from "../../../common/components/ScaleReconnection";
import Row from "../../../common/Row";
import { unitsToDisplay } from "../../../common/units/unitsToDisplay";
import { driverFacingErrorMessage } from "../../../common/userFacingMessages/userFacingMessages";
import useReceivingAcceptGrossWeight from "../../../requests/Receiving/useReceivingAcceptGrossWeight";

export interface ReceivingGrossWeightProps {
  siteId: string,
  scaleId: string,
  spoId: string,
  grossAccepted: (bayName?: string) => void;
  devToolItems?: React.ReactNode,
  officePhoneNumber?: string,
}

const ReceivingGrossWeight = (props: ReceivingGrossWeightProps) => {
  const { _ } = useLingui();
  const displayMessage = useDisplayMessage();

  const { weight: grossWeight, isReconnecting, showEscalationMessage } = useScaleWeight({
    siteId: props.siteId,
    scaleId: props.scaleId
  });

  const acceptGross = useReceivingAcceptGrossWeight(props.spoId, {
    onSuccess: ({ bayName }) => props.grossAccepted(bayName),
    onError: err => displayMessage.fail(_(driverFacingErrorMessage(err))),
  });

  return <Container
    title={_(msg`Verify Gross Weight`)}
    devToolItems={props.devToolItems}>
    <div className="m-auto w-75">
      <KaAlert
        displayMessage={displayMessage.message}
        onClose={displayMessage.clear} />
      {isReconnecting
        ? <ScaleReconnection
            showEscalationMessage={showEscalationMessage}
            officePhoneNumber={props.officePhoneNumber} />
        : <Row>
            <div className="col-auto mt-5">
              <label className="h5" htmlFor='grossWeight'><Trans>Gross Weight</Trans></label>
              <div className="input-group input-group-sm">
                <input
                  id='grossWeight'
                  type='text'
                  className='form-control form-control-sm p-2 text-end'
                  value={grossWeight.value}
                  readOnly />
                <div className="input-group-append input-group-text">
                  {_(unitsToDisplay(grossWeight.unit))}
                </div>
              </div>
            </div>
          </Row>
      }
    </div>
    <Footer nextButton={
      <FooterButton
        spinning={acceptGross.isLoading}
        onClick={() => acceptGross.request()}
        disabled={isReconnecting || !grossWeight.value || grossWeight.value <= 0}>
        <Trans>Accept Weight</Trans>
      </FooterButton>
    } />
  </Container>
}

export default ReceivingGrossWeight;